import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';

// MSAL imports
import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AuthenticationResult,
} from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import { MSAL_ENABLED } from './constants/global.constants';
import { Provider } from 'react-redux';
import store from './redux/store';
import './index.css';

export const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(
  document.getElementById('root-ai-chatbot') as HTMLElement,
);

if (MSAL_ENABLED) {
  msalInstance.initialize().then(() => {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }

    msalInstance.addEventCallback((event: EventMessage) => {
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload = event.payload as AuthenticationResult;
        const account = payload.account;
        msalInstance.setActiveAccount(account);
      }
    });

    root.render(
      <Provider store={store}>
        <Router>
          <App pca={msalInstance} />
        </Router>
      </Provider>,
    );
  });
} else {
  root.render(
    <Provider store={store}>
      <Router>
        <App pca={msalInstance} />
      </Router>
    </Provider>,
  );
}
